import groundcover from '@groundcover/browser';
import { telemetryEnabled } from './telemetry';

type LogLevel = 'error' | 'warn' | 'info' | 'debug';

function getError(args: unknown[]): Error | undefined {
	return args.find((a): a is Error => a instanceof Error);
}

function send(level: LogLevel, args: unknown[]): void {
	// Always log: local visibility, and the SDK's console instrumentation
	// ships this to Groundcover as a type:"log" event once initialized.
	// eslint-disable-next-line no-console -- this IS the console wrapper
	(console[level] as (...a: unknown[]) => void)(...args);

	if (!telemetryEnabled) return;

	// Errors additionally get a structured, stack-traced exception event
	const err = getError(args);
	if (err) {
		groundcover.captureException(err);
	}
}

const logger = {
	error: (...args: unknown[]) => send('error', args),
	warn: (...args: unknown[]) => send('warn', args),
	info: (...args: unknown[]) => send('info', args),
	debug: (...args: unknown[]) => send('debug', args),
	log: (...args: unknown[]) => send('info', args),
};

export default logger;
